import { frontendURL } from 'dashboard/helper/URLHelper';
import { ROLES, CONVERSATION_PERMISSIONS } from 'dashboard/constants/permissions.js';
import KanbanView from './KanbanView.vue';

// Kanban (custom Portela): visão read-only das conversas por status.
export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban_view',
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
    component: KanbanView,
  },
];
